/**
 * Custom Tooltip Component
 * Extends Ant Design Tooltip with custom styling
 */

import { Tooltip as AntTooltip } from 'antd';
import type { TooltipPropsWithTitle } from 'antd/es/tooltip';
import classNames from 'classnames';
import './CustomTooltip.scss';

export interface CustomTooltipProps extends TooltipPropsWithTitle {
  /** Tooltip variant */
  tooltipVariant?: 'default' | 'dark' | 'light';
}

/**
 * CustomTooltip Component
 */
export const CustomTooltip: React.FC<CustomTooltipProps> = ({
  tooltipVariant = 'default',
  ...rest
}) => {
  const tooltipClasses = classNames('custom-tooltip', `custom-tooltip--${tooltipVariant}`);

  return <AntTooltip {...rest} overlayClassName={tooltipClasses} mouseEnterDelay={0.1} />;
};

export default CustomTooltip;

